{
  "auth": {
    "onboarding": {
      "foreign": {
        "prompt": "Geben Sie Ihre ärztlichen Angaben ein.",
        "fullName": "Vollständiger Name",
        "specialty": "Fachrichtung",
        "specialtyPlaceholder": "z. B. Kardiologie",
        "specialtyChoose": "Fachrichtung wählen",
        "specialtyGroupSpecialty": "Fachrichtungen",
        "specialtyGroupSubspecialty": "Schwerpunkte",
        "specialtyOther": "Andere (nicht in der Liste)",
        "specialtyOtherLabel": "Ihre Fachrichtung",
        "specialtyUnknown": "Diese Fachrichtung ist nicht in der Liste. Bitte wählen Sie erneut.",
        "degree": "Abschluss",
        "degreePlaceholder": "z. B. MD oder MBChB",
        "country": "Ausstellungsland Ihrer Lizenz",
        "countryPlaceholder": "Land wählen",
        "city": "Stadt",
        "license": "Ärztliche Lizenznummer (optional)",
        "licenseHint": "Die Nummer, die Ihr eigenes Land vergeben hat.",
        "notice": "Diese Angaben werden ohne Prüfung gespeichert, und Ihr Profil wird als „Nicht verifiziert“ angezeigt.",
        "incomplete": "Geben Sie Name, Fachrichtung, Abschluss, Land und Stadt ein.",
        "licenseTaken": "Diese Lizenznummer ist bereits für ein anderes Konto registriert.",
        "notAllowed": "Dieser Weg ist nur für Nummern außerhalb Irans vorgesehen. Bitte geben Sie Ihre Ärztekammernummer ein.",
        "unverified": "Nicht verifiziert"
      }
    }
  }
}
